import { render, staticRenderFns } from "./CButton.vue?vue&type=template&id=2d4f3132&scoped=true"
import script from "./CButton.vue?vue&type=script&lang=js"
export * from "./CButton.vue?vue&type=script&lang=js"
import style0 from "./CButton.vue?vue&type=style&index=0&id=2d4f3132&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4f3132",
  null
  
)

export default component.exports